import type { CategoryContent } from '../row.js';

export const APPLIED_PHYSICS: CategoryContent = {
  bscba: [
    [
      'Wanneer licht van glas naar lucht reist, wat gebeurt er fysisch bij de kritische hoek?',
      [
        'De gebroken straal scheert langs het oppervlak bij 90°',
        'Het licht ondergaat gedeeltelijke reflectie en gedeeltelijke breking',
        'De golflengte neemt af wanneer de straal het glas verlaat',
        'Absorptie neemt toe omdat fotonen energie verliezen',
      ],
      0,
      'Bij de kritische hoek geeft de wet van Snell een brekingshoek van exact 90°, dus de straal komt evenwijdig aan het oppervlak tevoorschijn.',
    ],
    [
      'Welk gebied ontstaat aan de grens wanneer p-type en n-type halfgeleidermateriaal met elkaar in contact worden gebracht?',
      [
        'Een depletiegebied met een elektrisch veld door ladingscheiding',
        'Een geleidende laag die kortsluiting veroorzaakt over de overgang',
        'Een thermische barrière die stroomdoorgang voorkomt',
        'Een metalen interface met nulweerstand',
      ],
      0,
      'Diffusie van meerderheidsdragers veroorzaakt ladingscheiding en een ingebouwd elektrisch veld dat verdere diffusie stopt.',
    ],
    [
      'In stromingsleer stelt de vergelijking van Bernoulli behoud voor van welke grootheid langs een stroomlijn?',
      [
        'Mechanische energie per volume-eenheid',
        'Impulsmoment van de vloeistof',
        'Entropie bij constante temperatuur',
        'Chemisch potentieel van opgeloste ionen',
      ],
      0,
      'De vergelijking van Bernoulli is een vorm van energiebehoud: drukenergie, kinetische energie en zwaartekrachtpotentieel zijn constant.',
    ],
    [
      'Welke eigenschap van een materiaal is het product van zijn dichtheid en de geluidssnelheid erin?',
      [
        'Akoestische impedantie',
        'Akoestische dempingscoëfficiënt',
        'Akoestische resonantiefrequentie',
        'Akoestische dispersieparameter',
      ],
      0,
      'Akoestische impedantie (Z = ρc) bepaalt reflectie en transmissie van geluidsgolven op materiaalgrensen.',
    ],
    [
      'Hoe ontstaan röntgenstralen in een klinische buis?',
      [
        'Snelle elektronen raken een metaaldoel en geven fotonen af via vertraging',
        'Geïoniseerde atomen in een gas geven karakteristieke straling af',
        'Radioactief verval van wolfraamkernen in de buis',
        'Wrijving tussen roterende elektrodes genereert elektromagnetische straling',
      ],
      0,
      'Elektronen versneld over een potentiaal treffen de anode; vertraging geeft energie af als röntgenstralen (Bremsstrahlung) of karakteristieke fotonen.',
    ],
    [
      'Wat is het primaire mechanisme van warmteoverdracht door een vaste metaalstaaf tussen twee warmtebronnen?',
      [
        'Geleiding via fononen en vrije elektronen',
        'Convectie wanneer metaalatomen fysiek door de staaf bewegen',
        'Straling van thermische trillingen in het metaalrooster',
        'Faseverandering op de grens tussen hete en koude gebieden',
      ],
      0,
      'In metalen gebeurt geleiding via fononen (roostertrillingen) en elektrontransport; convectie en straling zijn verwaarloosbaar in vaste stoffen.',
    ],
    [
      'Een laserstraal wordt gekarakteriseerd door coherentie. Wat betekent coherentie in deze context?',
      [
        'Golven behouden een constante faseverhouding',
        'De straal reist in een volkomen rechte lijn zonder divergentie',
        'Alle fotonen worden gelijktijdig in één uitbarsting uitgestraald',
        'De straaldichtheid is uniform over de volledige doorsnede',
      ],
      0,
      'Coherentie betekent dat golven een stabiele faseverhouding hebben—coherent licht van een laser interfereert constructief, anders dan incoherente bronnen.',
    ],
    [
      'De continuïteitsvergelijking in stromingsdynamica stelt dat wanneer vloeistof door een vernauwde pijp stroomt, wat moet toenemen?',
      [
        'De snelheid van de vloeistof',
        'De druk in de pijp',
        'De viscositeit van de vloeistof',
        'De dichtheid bij constante temperatuur',
      ],
      0,
      'Continuïteitsvergelijking: ρAv = constant (massastroom behouden). Kleinere oppervlakte A vereist grotere snelheid v bij constante dichtheid.',
    ],
    [
      'Waarom reist geluid sneller door water dan door lucht bij dezelfde temperatuur?',
      [
        'De samendrukbaarheid van water geeft snellere spanningsgolven',
        'Water heeft meer zuurstofmoleculen die sneller trillen',
        'Geluidsgolven in water zijn elektromagnetisch in plaats van mechanisch',
        'Zoutgehalte in water verhoogt de snelheid van akoestische golven',
      ],
      0,
      'Geluidssnelheid is c = √(K/ρ), waarbij K samendrukbaarheid is. De hogere samendrukbaarheid van water weegt zwaarder dan de hogere dichtheid.',
    ],
    [
      'In een voorwaarts gepolariseerde p-n-junctie diode, wat veroorzaakt stroomdoorgang over de junctie?',
      [
        'Externe spanning verkleint het depletiegebied',
        'Elektronen en gaten ontstaan door thermische energie in de junctie',
        'Het depletiegebied wordt dikker en leidt gemakkelijker',
        'Tunneling door het depletiegebied gebeurt op kamertemperatuur',
      ],
      0,
      'Voorwaartse bias verkleint het depletiegebied, verlaagt de barrière zodat meerderheidsdragers diffunderen en driftstroom overstijgen.',
    ],
    [
      'Glasvezeloptiek vertrouwt op licht dat door de kern reist vanwege herhaalde totale interne reflectie. Waarom geen spiegelgevoerde holle buis gebruiken?',
      [
        'Glasvezel geleidt licht met veel lager verlies dan spiegels',
        'Spiegelbuis vereist vacuüm, terwijl vezel in elke omgeving werkt',
        'Licht reist sneller door vast glas dan in lucht of vacuüm',
        'Vezel is goedkoper in massaproductie',
      ],
      0,
      'Optische vezels bereiken laag verlies via totale interne reflectie; spiegelbuizen verstrooien, absorberen en kunnen kwaliteit niet behouden.',
    ],
    [
      'In warmtewisselaarconfiguratie, wat is de primaire warmteoverdrachtswijze over de dunne metalen wand tussen twee vloeistoffen?',
      [
        'Geleiding door de metalen wand',
        'Convectie van één vloeistof naar de wand, dan naar de andere',
        'Straling van één vloeistofoppervlak naar het ander',
        'Faseverandering aan één zijde die latente warmte vrijgeeft',
      ],
      0,
      'Primaire wijze is geleiding door de wand; convectie gebeurt in elke vloeistof, maar de wand zelf geeft warmte af door geleiding.',
    ],
    [
      'Een autoclaxon beweegt met hoge snelheid naar je toe. Waarom klinkt de toon hoger dan wanneer hij stilstaat?',
      [
        'Beweging comprimeert de golflengte, verhoogt de toonhoogte',
        'De claxon straalt meer vermogen uit wanneer hij beweegt, dus de amplitude neemt toe',
        'Dopplereffect verandert de geluidssnelheid in lucht',
        'De acceleratie van de auto creëert een resonantiecaviteiteffect',
      ],
      0,
      'Dopplereffect: bron beweegt naar waarnemer toe verkort golflengte λ = v/(f + v_bron/c), verhoogt gehoorde frequentie.',
    ],
    [
      'Een fotodiode zet licht om in elektrische stroom. Welk kwantumproces maakt deze omzetting mogelijk?',
      [
        'Fotonen exciteren elektronen over de bandgap',
        'Licht verwarmt het materiaal, verhoogt elektronische thermische snelheid',
        'Fotonen dragen rechtstreeks momentum over op elektronen zonder energieverlies',
        'Laserlicht induceert gestimuleerde emissie die in stroom cascadeert',
      ],
      0,
      'Fotonen exciteren dragers in de bandgap; het junctieveld scheidt ze voor recombinatie, creëert meetbare fotostroom.',
    ],
    [
      'In nucleaire techniek correspondeert de macroscopische doorsnede Σ = N·σ met de microscopische doorsnede σ. Wat stelt N voor?',
      [
        'Atoomgetalsdichtheid per volume-eenheid',
        'Aantal neutronen per splijting uitgestraald',
        'Totaal massagetal van de kern',
        'Aantal reacties per seconde uitgevoerd',
      ],
      0,
      'Macroscopische doorsnede is microscopische doorsnede geschaald naar getalsdichtheid; voorspelt hoe waarschijnlijk een neutron in het materiaal reageert.',
    ],
  ],
  msc: [
    [
      'Gestimuleerde Ramanverstrooiing in een glasvezellink wordt problematisch boven een bepaalde vermogensdrempel. Welk fysisch mechanisme beperkt versterking?',
      [
        'Niet-lineaire pompuitputting vermindert de versterking',
        'Thermische uitzetting van de vezelkern verlaagt de brekingsindex',
        'Rayleigh-verstrooiing van de Stokes-golf domineert bij hoog vermogen',
        'Spontane emissie in de vezel wordt incoherent en injecteert ruis',
      ],
      0,
      'Gestimuleerde Ramanverstrooiing is niet-lineair: pompuitputting wordt significant boven drempel, beperkt energieoverdracht naar Stokes-golf.',
    ],
    [
      'In III-V halfgeleiderheterojuncties voor LED\'s, waarom is de bandgapenergie van de mantellaag groter dan die van de actieve laag?',
      [
        'Een potentiaalput sluit dragers op in de actieve laag',
        'Optische transparantie in mantel voorkomt verlies van uitgestraalde fotonen',
        'Roosterconstante mismatch vereist samengestelde gradiënt',
        'Thermisch management: bredere-kloof materialen geleiden warmte efficiënter',
      ],
      0,
      'Heterojuncties creëren potentiaalbarrières; brede-kloof mantel sluit dragers op in smallere-kloof actieve laag, verbetert recombinatie daar.',
    ],
    [
      'In computationele stromingsdynamica (CFD) is turbulente stroming gesloten door termen toe te voegen aan de Navier-Stokes-vergelijking. Hoe heet deze sluiting typisch?',
      [
        'Turbulentiemodellering via wervelviscositeit',
        'Spectrale decompositie van vorticiteitsveldenstructuur',
        'Tijdsgemiddeling om fluctuerende druktermen te elimineren',
        'Kunstmatige diffusie om numerieke schema\'s te stabiliseren',
      ],
      0,
      'Turbulentiesluiting (k-ε, k-ω, Spalart-Allmaras) benadert onopgeloste schaaleffecten via wervelviscositeit.',
    ],
    [
      'In echografische fasenreeks-beeldvorming, hoe stelt tijdvertragingsfocussering de ruimtelijke resolutie in de axiale richting in?',
      [
        'Vertragingen bundelen constructieve interferentie op één diepte',
        'Vertraagde signalen verstrooien minder van off-axis structuren',
        'Frequentieveranderingen door het Dopplereffect maken dieptediscriminatie mogelijk',
        'Akoestische impedantiemismatch varieert met diepte, verbetert grenzen',
      ],
      0,
      'Fasegroep: transmissievertragingen lijnen golffronten op aan gekozen diepte z; reflecties van die diepte interfereren constructief, andere annuleren.',
    ],
    [
      'Een synchrotron röntgenstralenlijn gebruikt silicium(111)-analyseerkristal voor energieresolutie. Wat is het onderliggende beginsel?',
      [
        'Het kristal heeft een smalle Darwin-curve in energie',
        'De thermische trillingen van het kristal zijn geminimaliseerd, wat de terugstootverschuiving vermindert',
        'Silicium(111)-vlakken zijn volkomen evenwijdig, elimineren geometrische verbreding',
        'De analyzer selecteert fotonen op golflengte via het fotoëlektrisch effect',
      ],
      0,
      'Darwin-curve (dynamische diffractie): alleen fotonen in zeer smal energievenster voldoen aan Bragg-voorwaarde op analyservlak.',
    ],
    [
      'Waarom daalt de warmtegeleiding van koper naarmate de temperatuur stijgt, ondanks meer trillingen?',
      [
        'Umklapp-verstrooiing verkort de vrije weglengte van fononen',
        'Elektronen worden minder vrij wanneer het rooster uitzet',
        'Het Ferminiveau stijgt en verlaagt de toestandsdichtheid',
        'Koper ondergaat een faseverandering die geleiding vermindert',
      ],
      0,
      'Boven de Debyetemperatuur domineert Umklapp-verstrooiing: fonon-fonon botsingen verkorten vrije weglengte sneller dan T-verbeteringen.',
    ],
    [
      'In extern gemoduleerde lithiumniobaat-Mach-Zehnder-modulatoren, hoe moduleert een aangelegde spanning de intensiteit van licht?',
      [
        'Spanning verschuift de brekingsindex via het Pockels-effect',
        'Spanning ioniseert rechtstreeks opgesloten elektronen, verandert absorptie',
        'Spanning induceert dubbelbrekking die de straal splitst',
        'Spanning verschuift de bandgap, verandert fotonen-fononkoppeling',
      ],
      0,
      'Pockels-effect (lineair elektro-optisch): spanning Δφ = (π/2)(V/Vπ) verschuift fase; destructieve/constructieve interferentie moduleert uitvoer.',
    ],
    [
      'In polymeermatrixcomposietmaterialen beïnvloeden vezelrichting en vezel-matrixhechting beide de stijfheid. Welke heeft meer effect op longitudinale modulus bij hoge vezelfractie?',
      [
        'Vezelrichting domineert de longitudinale modulus',
        'Hechting is kritischer; slechte binding ontkent de bijdrage van vezels ongeacht richting',
        'Beide dragen gelijk omdat Poisson-verhouding ze koppelt',
        'Volumefractie alleen bepaalt modulus onafhankelijk van richting of hechting',
      ],
      0,
      'Mengselregel met richtingsfactor: longitudinale modulus E = ηη_o ηL (Ef Vf + Em Vm). Misrichtingsfactor (η) domineert bij hoge Vf.',
    ],
    [
      'Akoesto-optische afleiders in laserscansystemen vertrouwen op een reizende akoestische golf om licht af te buigen. Wat bepaalt de afbuigingshoek?',
      [
        'Hogere akoestische frequentie vergroot de afbuigingshoek',
        'De lasergolflengte ten opzichte van de akoestische golflengte',
        'De intensiteit van de akoestische golf, wat bepaalt hoeveel fononen verstrooien',
        'De piezo-elektrische coëfficiënt van de gebruikte kristallen',
      ],
      0,
      'Akoesto-optische afbuigingshoek θ ≈ λ_licht × ν_akoestisch / v_geluid; hogere akoestische frequentie verhoogt effectieve roosterperiode.',
    ],
    [
      'In kernreactorneutroninologie geeft vermenigvuldigingsfactor k_eff > 1 een divergerende kettingreactie aan. Wat is de fysische oorsprong van vermenigvuldiging?',
      [
        'Elke splijting geeft neutronen af die meer splijting veroorzaken',
        'Neutronenvangst in niet-splijtstoffen geeft secundaire neutronen af',
        'Moderatorathermalisering zet snelle neutronen oneindig in langzame neutronen om',
        'Vervalwarmte van splijtstoffen creëert extra thermische neutronen',
      ],
      0,
      'k_eff is het gemiddeld aantal neutronen uit één generatie dat splijting in volgende veroorzaakt; k > 1 betekent exponentiële groei.',
    ],
    [
      'In krachtige x86-processors beperkt thermisch bewuste klokvertraging frequentie wanneer junctietemperatuur een drempel overschrijdt. Waarom is vertraging noodzakelijk?',
      [
        'Lekstroom en elektromigratie stijgen exponentieel met temperatuur',
        'Hogere temperatuur veroorzaakt fysieke transistoruitzetting buiten chipgrens',
        'Voedingsspanning kan niet boven bepaalde temperatuur worden gehandhaafd',
        'Thermische weglopen wordt voorkomen door voedingsspanning proportioneel te verminderen',
      ],
      0,
      'Lekkage Pₗₑₖ ∝ exp(qEₐ/kT) en elektromigratiegemiddelde tijd ∝ exp(-ΔEₐ/kT) zijn exponentieel in T; vertraging voorkomt falen.',
    ],
    [
      'In medische echografie veroorzaakt het akoestische stromingseffect vloeistofbeweging zonder bulkstroom. Wat is het mechanisme?',
      [
        'Stralingdruk oefent een gestage niet-lineaire kracht uit op deeltjes',
        'Akoestische cavitatie creëert bellen die ineenstorten en vloeistof opzij duwen',
        'De piëzo-elektrische transducer trilt op audiofrequenties, roert het medium mechanisch',
        'Thermische gradiënten van absorptie creëren convectiestromen',
      ],
      0,
      'Akoestische stroming: niet-lineaire stralingkracht ∝ I²/c op absorberende deeltjes creëert steady-state circulatie van transiënte effecten.',
    ],
    [
      'In een thermoacoustische motor drijft een temperatuurgradiënt langs een stapel akoestische oscillaties aan. Welke thermodynamische cyclus lijkt dit op?',
      [
        'Gaspaketten cyclen tussen warm en koud, als een Stirling-motor',
        'Carnot-cyclus waarbij de stapel de zuigermotor vervangt',
        'Brayton-cyclus waarin werkstof met constant druk stroomt',
        'Otto-cyclus gecomprimeerd in akoestische golf in plaats van discrete slagen',
      ],
      0,
      'Thermoacoustisch: gaspaketten oscilleren tussen hete en koude zones, ondergaan druk-temperatuurveranderingen analoog aan een Stirling-motor.',
    ],
    [
      'In avalanche-fotodiodes (APD\'s) verlengt interne versterking van ionisatieimpact het bruikbare signaalgebied, maar introduceert ruis. Wat is de primaire ruisbron?',
      [
        'Ionisatie-impact varieert willekeurig tussen dragers',
        'Thermische ruis van hoge reverse-bias spanning',
        'Tunneling-geïnduceerde donkerstroom die niet wordt versterkt',
        'Spontane emissie van fotonen in de junctie',
      ],
      0,
      'Lavieneruis: het aantal secundaire dragers per primaire varieert willekeurig; excessieve ruisfactor F > M (versterking) vanwege stochastiek.',
    ],
    [
      'Terahertz-straling (0.1–10 THz) ligt tussen microgolven en infrarood. Waarom is THz-generatie en -detectie moeilijker dan aangrenzende frequenties?',
      [
        'THz zit tussen de kwantum- en golflengtelimieten van engineering',
        'THz wordt sterk geabsorbeerd door waterdamp onder alle drukken',
        'Er bestaan geen halfgeleidermaterialen met bandgaps in THz-energiebereik',
        'Kwantumtunneling van ladingsdragers voorkomt THz-voortplanting in halfgeleiders',
      ],
      0,
      'THz-gat: kwantumgrens E = hν sluit eenvoudige halfgeleiders uit; golflengte λ ∼ mm sluit conventionele RF uit; technische zonetuitstekend.',
    ],
  ],
  phd: [
    [
      'In niet-lineaire glasvezeloptiek verbreed zelf-fasemodulatie (SPM) een pulsspectra terwijl energie behouden blijft. Wat is het onderliggende niet-lineaire mechanisme?',
      [
        'Intensiteit moduleert de index via χ(3)-niet-lineariteit',
        'Gestimuleerde Ramanverstrooiing rood-verschuift spectrum terwijl SPM puls comprimeert',
        'Twee-foton absorptie creëert verliesgradiënt die puls in tijd uitrekt',
        'Kerr-rotatie van polarisatie koppelt modus-orthogonale temporale modi',
      ],
      0,
      'SPM: φ_NL(t) = γ P(t) L verschuift pulfase; hogere intensiteit op piek ziet grotere verschuiving, creëert chirp Δν ∝ dP/dt.',
    ],
    [
      'In molecuulbundelepitaxie (MBE), waarom is groeisnelheid meestal beperkt tot ∼1 μm/uur ondanks moleculaire bundeldichtheden van 10¹⁶ cm⁻² s⁻¹?',
      [
        'Verblijftijd en diffusiekinetiek beperken hoeveel atomen hechten',
        'Vacuümkamer kan hoger afzettingspercentage niet ondersteunen zonder overmatige ontgassing',
        'Thermische straling van substraat beperkt maximale temperatuur',
        'Elektronenkanon voor reflectie-hogeënergie-elektronendiffractie (RHEED) beschadigt oppervlak bij hogere snelheid',
      ],
      0,
      'MBE-tempo beperkt door verblijftijd τᵣ en stap-diffusie; lage T verbetert kleving, hoge T verhoogt diffusielengte maar vermindert τᵣ.',
    ],
    [
      'In directe numerieke simulatie (DNS) van turbulentie, waarom is rekenkosten prohibitief voor hoge Reynolds-getallen?',
      [
        'Het raster moet de Kolmogorov-lengte volgen, kosten schalen steil met Re',
        'Turbulentie is chaotisch; nauwkeurige voorspelling vereist exponentieel langere tijdstappen',
        'De Navier-Stokes-vergelijkingen worden boven kritische Reynolds-getal singulier',
        'Moleculaire diffusie-effecten worden dominant bij hoge Re, vereisen kwantumsimulatie',
      ],
      0,
      'DNS-kosten: raster ∝ (Re d/η)³ ∝ Re^(9/4); tijdstappen ∝ Re^(1/4); totaal ∝ Re^(11/4) ≈ Re^2.75, prohibitief boven Re ∼ 5000.',
    ],
    [
      'In oktupoolversterkende kernresonantiefluorescentie (NRF), waarom kunnen kernen met nulkwadrupoolmoment (Q = 0) smalere resonanties tonen dan enkel-dipoolovergangen?',
      [
        'Oktupooltransities hebben langere levensduren en geen kwadrupoolmengsel',
        'Nulkwadrupoolmoment voorkomt hyperfijnverbreding',
        'Oktupooltransities zijn zuiver magnetisch, vermijdt elektrische-veldfluctuaties',
        'NRF-resonanties verscherpen omdat fotonen-terugslag in kern wordt geëlimineerd',
      ],
      0,
      'Oktupoolvervallen A₈ < A₂; resonantiebreedte Γ ∝ A stijgt, maar geen kwadrupoolmengsel voorkomt extra verbredingsmechanismen.',
    ],
    [
      'In silicium-fotoveelvoudigers (SiPM\'s) werken Geiger-modus avalanche-fotodiodes parallel met geïntegreerde uitdovers. Welk voordeel geeft parallelarchitectuur over afzonderlijke APD\'s?',
      [
        'Onafhankelijke pixelontladingen geven proportionele fotontelling',
        'Parallelle pixels verminderen vereiste bedrijfsspanning voor ionisatie-impact',
        'De uitdovers voorkomen volledig nagloeiingen of donkertellingen',
        'Pixelkruis-communicatie maakt signaalversterking voorbij enkelvoudige-fotonengevoeligheid mogelijk',
      ],
      0,
      'SiPM: elke pixel telt 1 foton; veel pixels ontladen = proportionele uitvoer; uitdovertijd τ_q per pixel is kort, vult dode tijd.',
    ],
    [
      'In ferrovloeistofdynamica veroorzaakt de magnetische veldgradiënt dat deeltjesketens vormen en interageren. Waarom stijgt bulkviscositeit dramatisch boven kritieke veldsterkte?',
      [
        'Veldketens vormen lastdragende structuren die schuifspanning weerstaan',
        'Thermische energie smelt ketens, verhoogt moleculaire beweging',
        'Magnetische dipoolwisselwerking wordt afstotend bij hoog veld',
        'IJzeroxydedeeltjes ondergaan fasescheiding, vangen vloeistof tussen aggregaten',
      ],
      0,
      'Veldgeïnduceerde structuren (ketens, kolommen) roteren met schuifstroom; hun structuur-dissociatiekinetiek domineert visceuze spanning boven drempel.',
    ],
    [
      'In röntgenkristallografie op synchrotrons onderdrukt harmonischen-afwijzing met Si(999)-reflectie hogere-orde vervuiling. Waarom niet simpelweg een monochromator-filter gebruiken?',
      [
        'Alleen de 9e-orde reflectie voldoet aan de Bragg-voorwaarde op die glanshoek',
        'Si(999) is immuun voor thermische vervorming omdat het diep in het rooster is gebonden',
        'Harmonischefiltering vermindert coherentie, terwijl Si(999) transversale coherentie bewaart',
        'Alleen Si(999) kan vereist fotonenflux bereiken bij harde röntgen-energieën',
      ],
      0,
      'Bragg-vergelijking: 2d sinθ = nλ; Si(999) heeft roosterafstand d/9; hoge-orde (n=9) reflecteert bij glanshoek, de grondtoon kan niet aan de Bragg-voorwaarde voldoen.',
    ],
    [
      'In superkritische vloeistofextractie (SFE), waarom piekt extractieeffectiviteit bij specifieke dichtheid nabij kritisch punt in plaats van monotoon toe te nemen met druk?',
      [
        'Nabij het kritisch punt stemt druk dichtheid scherp af',
        'Superkritische vloeistoffen ondergaan faseverandering op kritisch punt die oplosten opsluit',
        'Het kritische punt veroorzaakt cavitatie die extractievat beschadigt',
        'Entropie domineert over enthalpie boven kritisch punt, vermindert extractie',
      ],
      0,
      'Nabij kritisch punt: ∂ρ/∂P divergeert; oplosvermogen (∝ dichtheid) piekt; verdere P-stijging verhoogt ρ maar vermindert resterende interacties.',
    ],
    [
      'In hoog-harmonisch-generatie (HHG) van atoomgassen aangedreven door intense infrarode lasers, wat voorkomt efficiënte generatie voorbij ionisatieplateauharmonieken?',
      [
        'Uitputting van neutrale atomen beperkt harmonische straling uit het plasma',
        'Harmonischen voorbij plateau hebben golflengte korter dan laserspot, diffracteren weg van generatiegebied',
        'Kwantumdefect van aangeslagen toestanden verhoogt voor hoger-liggende toestanden, onderdrukt recombinatie',
        'Fasekoppeling breekt af omdat groepssnelheid-mismatch ondraaglijk wordt',
      ],
      0,
      'HHG-plateau: recombinatie van geïoniseerde atomen produceert harmonischen; uitputting van neutrale populatie en vrij-vrij absorptie in plasma beperken efficiëntie voorbij plateau.',
    ],
    [
      'In seismische golfgeleider-voortplanting, waarom vertonen geleide P-golven langs een dichte oppervlaktelaag een keerpuntstructuur in diepte die frequentie-afhankelijk is?',
      [
        'Stijgende snelheid met diepte keert lage frequenties diep en hoge ondiep',
        'Poisson-verhouding varieert met diepte, creëert dispersief medium',
        'Verzwakking is frequentie-afhankelijk, verhindert dat laagfrequente golven diep doordringen',
        'Laagdikte is golflengte-afhankelijk, beperkt alleen bepaalde modi',
      ],
      0,
      'Seismische golfgeleider: v(z) stijgt met diepte; frequentie-afhankelijke indringingsdiepte creëert keerpuntstructuur analoog aan optische WKB-voortplanting.',
    ],
    [
      'In kwantumcascadeladders (QCL\'s) gebeurt de optische overgang tussen dicht gestapelde subbanden in het geleidingsband (ΔE ∼ 100 meV), niet tussen verre banden. Waarom is dit ontwerp voordelig?',
      [
        'Engineered subbandafstand stelt de infraroodgolflengte direct af',
        'Dicht gestapelde subbanden verminderen thermische verbreding van laserlijnbreedte',
        'Subbandovergangen elimineren Auger-recombinatie, verlengen apparaatlevensduur',
        'De laser kan golflengten bereiken die onmogelijk zijn met conventionele halfgeleiders',
      ],
      0,
      'QCL: engineered subbanden via kwantumopsluiting; subbandovergangen ontkoppelen golflengte van bandgap; directe stroominjectie pompt populatieinversie.',
    ],
    [
      'In fractioneel kwantum-Hall-effect (FQHE) verschijnen samengestelde fermionen als gebonden toestanden van elektronen en magnetische fluxquanta. Waarom vereenvoudigt dit het veel-lichaamsprobleem?',
      [
        'Fluxaanhechting kaart de toestand naar geheel-getal vulling van fermionen',
        'Fluxquantisering beperkt totaal deeltjes, maakt toestand uniek',
        'Elektron-elektron interacties worden verwaarloosbaar in FQHE-regime',
        'FQHE-toestand is niet-gedegenereerd, elimineert topologische-orde complexiteit',
      ],
      0,
      'CF-beeld: voeg fluxquanta aan elektronen toe; ν_CF = ν/(2nν+1); gereduceerd effectief B zet FQHE op ν om naar geheel-getal QHE in CF-beeld.',
    ],
    [
      'In resonante röntgenverstrooiing (RXS) bij absorptiekanten, versterkt resonante vergroting van specifieke verstrooitopieken lading- of orbitalevolgorde. Waarom zijn RXS-spectra gevoeliger voor subtiele ordening dan niet-resonante diffractie?',
      [
        'Resonantie versterkt verstrooiing die in niet-resonante diffractie verboden is',
        'Resonante verstrooiing elimineert meervoudige verstrooiing, verbetert hoekcresolutie',
        'RXS is immuun voor spanningsgeïnduceerde piekverbreding',
        'Coherentielengte divergeert bij resonantie, laat nanoschalige-orde detectie toe',
      ],
      0,
      'RXS: resonante versterking bij absorptiekant breekt niet-resonante selectieregels; verboden reflecties worden toegestaan, onderzoeken site-specifieke ordening.',
    ],
    [
      'In elektromagnetisch veroorzaakte transparantie (EIT) wordt een zwakke testlaser transparant wanneer een sterke besturingslaser twee atomaire transities koppelt. Wat is het onderliggende mechanisme?',
      [
        'Een donkere-toestand superpositie annuleert testabsorptie destructief',
        'Besturingslaser ioniseert bovenste toestand, voorkomt testabsorptie',
        'Rabi-oscillaties van besturingslaser veroorzaken snelle aangeslagen-toestand verval',
        'Besturingslaser verschuift atoomresonantiefrequentie weg van testgolflengte',
      ],
      0,
      'EIT: duistere-toestand superpositie (adiabatische eigentoestand) koppelt niet aan test; destructieve kwantuminterferentie annuleert absorptie via 3-niveaus Λ systeem.',
    ],
    [
      'In microfluidische elektrokinetische instabiliteit vertoont een dun permselectief membraan (ionenwisselaag) onder een hoog elektrisch veld wervelrolcellen. Wat triggert de instabiliteit?',
      [
        'Ionpolarisatie destabiliseert de stroming aan het interface',
        'Het membraan ondergaat ladingomkering bij hoge spanning',
        'Joule-verhitting veroorzaakt thermische convectie in het membraan',
        'Elektroforese van macromoleculen creëert secundaire stroom',
      ],
      0,
      'EEKI: zoutverdeling in één regio, verrijking in ander; ∇ρ koppelt aan elektrisch veld E, drijft secundaire stroom aan; niet-lineaire elektrokinetiek versterkt wervels.',
    ],
  ],
  professor: [
    [
      'In context van laser-plasma-instabiliteiten tijdens traagheidsopsluiting fusie (ICF) hohlraum-verwarming kunnen gestimuleerde Ramanverstrooiing (SRS) en gestimuleerde Brillouinverstrooiing (SBS) via gemeenschappelijke ion-akoestische golf koppelen. Wat is de fysische gevolg van deze koppeling?',
      [
        'Koppeling verlaagt de drempel voor parametrische pompuitputting',
        'Koppeling verhoogt Stokes-golflengtefrequentieverschuiving voorbij Raman- of Brillouinfrequentie alleen',
        'Ion-akoestische golven worden zelf-sustenend en genereren elektromagnetische ruis',
        'Pompbundel splitst in twee duidelijke gebroken bundels met verschillende golfvectoren',
      ],
      0,
      'SRS-SBS koppeling: ion-akoestische golf katalyseert energieoverdracht van pomp naar Stokes met lagere drempel; beide verstrooiingskanalen voeden dezelfde akoestische modus.',
    ],
    [
      'In topologische fotonica breken vallei-Hall fotonische kristallen tijd-omkering symmetrie om eenrichtingsflanken te creëren. Hoe behoudt fotonica vallei-Hall effect directionaliteit zonder magnetische velden?',
      [
        'Gebroken symmetrie geeft valleien tegengestelde Berry-kromming en chiraliteit',
        'Optische activiteit (natuurlijke cirkelvormige dichroïsme) van materiaal breekt tijd-omkering symmetrie',
        'Ruimtelijk variërende niet-lineaire absorptie creëert effectief niet-reciprook medium',
        'Fotonenbandspleet opent en sluit periodiek, beperkt licht op grenzen',
      ],
      0,
      'Vallei-Hall effect: C₃ breking → tegengestelde Berry-kromming op K, K\'; terugverstrooiing van vallei-vergrendelde randtoestanden is verboden door vallei-chiraliteitsbehoud.',
    ],
    [
      'In geavanceerde kernreactorbrandstof (TRISO-deeltjes) kan de SiC-coatingslaag splijtingsproductdruk en temperatuurgradiënt ondergaan zonder falen. Welk atomair-schaal mechanisme stelt SiC in staat sterkte tot ∼1600 °C te behouden?',
      [
        'Sterke covalente Si-C-bindingen houden puntdefectmobiliteit laag tot ∼1600 °C',
        'SiC vormt niet-kristallijne beschermlaag die splijtingsgasverspreiding voorkomt',
        'De SiC-kristalstructuur ondergaat faseverandering die mechanische stabiliteit vergrendelt',
        'Splijtingsfragmenten chemisch binden aan SiC-rooster, versterken het lokaal',
      ],
      0,
      'SiC: hoge kT_D, grote Eₘ voor dislocatie-kruip; onder ∼1600 °C is Nabarro-Herring-kruip verwaarloosbaar; puntdefectdichtheid blijft laag.',
    ],
    [
      'In scanning-tunnelmicroscopie (STM) van een metaal is tunnelstroom I exponentieel gevoelig voor spalafstand z. Op monsters met elektronische wanorde (b.v. oppervlakteruwheid van toestandsdichtheid) vertoont constant-stroom STM een schijnbare topografie die niet overeenkomt met de fysieke topografie. Waarom treedt dit artefact op?',
      [
        'Terugkoppeling past tiphoogte aan om I vast te houden, en kaart zo DOS, niet echte topografie',
        'Thermische trillingen van tip verbreden tunnelresonantie, verminderen ruimtelijke resolutie',
        'De tunnelbarrièrehoogte verandert met monstersamenstelling, beïnvloedt exponentiële gevoeligheid',
        'Tip-monster interacties creëren aantrekkende kracht die elektronische effecten domineert',
      ],
      0,
      'STM constant-stroom: I ∝ exp(z) ρ(E_F); terugkoppeling handhaaft I, dus z volgt ρ(E_F)-variaties—elektronische correctie, niet topografisch.',
    ],
    [
      'In femtoseconde-laserablatie van vaste stoffen, vermijden ultrakorte pulsen thermische verspreiding in bulk. Echter, de ablatiedrempel (vloeistof Fₜₕ) vertoont niet-monotoon afhankelijkheid van pulduur τ onder ∼100 fs. Wat veroorzaakt deze non-monotoniciteit?',
      [
        'Onder de elektron-fonon-koppelingstijd vragen kortere pulsen hogere fluence',
        'Onder 100 fs wordt meervoudige-foton ionisatie dominant, verhoogt ionisatiedrempel',
        'De lasergolflengte verschuift naar ultraviolet, verlaagt absorptie doorsnede',
        'Plasmascherm voorkomt kortere pulsen het oppervlak bereiken',
      ],
      0,
      'Femtoseconde-ablatie: τ < τₑₚ (elektron-fononkoppelingstijd ∼ 100 fs) → elektronen verwarmen voor equilibratie; langere τ laat fononsaccumulatie toe, verlaagt Fₜₕ.',
    ],
    [
      'In magnetohydrodynamische (MHD) turbulentie onderhevig aan sterk achtergrond magnetisch veld B₀ is energiecascade anisotropisch: turbulente wervels rekken zich voorkeur langs B₀, creëren "potloodvormig" spectrum in k-ruimte. Welk fundamentaal verschil in moduskoppeling veroorzaakt deze anisotropie vergeleken met normale vloeibare turbulentie?',
      [
        'Magnetische spanning onderdrukt loodrechte beweging, bevoordeelt cascade langs B₀',
        'Alfvén-golfdispersierelatie ω = vₐ k‖ beperkt cascade naar parallelle golfnumers',
        'Visceuze dissipatie is anisotropisch vanwege anisotropische viscositeit in gemagnetiseerd plasma',
        'Magnetische reconnectie creëert smalle stroomvellen die loodrechte turbulentie fragmenteren',
      ],
      0,
      'MHD-anisotropie: B₀ onderdrukt Alfvén-golfinteractie ⊥ tot B; parallelle cascade domineert; loodrechte modi koppelen zwak → potloodspectrum.',
    ],
    [
      'In superkritische wateroxidatie (SCWO) voor gevaarlijke-afval behandeling kan ionenproduct K_w van water nabij kritisch punt (374 °C, 22 MPa) tot 10⁻¹¹ zijn, veel hoger dan 10⁻¹⁴ bij 25 °C. Hoe beïnvloedt deze dramatische K_w-verandering reactiekinetiek van organische oxidatie?',
      [
        'Hoger K_w verhoogt [H⁺]/[OH⁻] en versterkt •OH-radicalen en oxidatie',
        'Hoger K_w verlaagt oplosbaarheid van organische stoffen, vertraagt oxidatie',
        'De diëlektrische constante van water daalt nabij T_c, verlaagt ionendissociatie ondanks hoger K_w',
        'Superkritisch water remt water-gemedieerde radicaal reacties, vereist alternatieve paden',
      ],
      0,
      'SCWO: superkritisch H₂O heeft K_w ∼ 10⁻¹¹; [H⁺][OH⁻] → 10⁻¹¹ M²; •OH-generatie via ketenreacties versnelt vrij-radicaal oxidatie van organica.',
    ],
    [
      'In optische-frequentie-kammen van modus-vergrendelde femtoseconde lasers staan frequentie-kamtanden afstand door Δfᵣₑₚ (repetitiefrequentie) en offset door f_CEO (drager-envelop-offset frequentie). Waarom is stabilisering f_CEO kritiek voor breedbandspectromen beurzen, terwijl Δfᵣₑₚ vergelijkend los kan zijn?',
      [
        'f_CEO bepaalt de absolute kamtandfrequentie; Δfᵣₑₚ bepaalt alleen de afstand',
        'f_CEO bepaalt de golfvorm van de laserpuls; Δfᵣₑₚ beïnvloedt outputintensiteit niet',
        'f_CEO vergrendelt spectrum naar optische resonanties; Δfᵣₑₚ is automatisch bepaald door caviteitslengte',
        'Stabilisering Δfᵣₑₚ is onmogelijk; alleen f_CEO kan elektronisch worden bestuurd',
      ],
      0,
      'f_CEO: tand m heeft frequentie fₘ = m·Δfᵣₑₚ + f_CEO; f_CEO drift → alle tanden verschuiven in abs. freq., breekt coherentie. Δfᵣₑₚ drift → afstandsfout, gering voor breedband.',
    ],
    [
      'In plasmonische metamaterialen ontworpen met sub-golflengte kenmerken, kan effectieve magnetische permeabiliteit μ_eff negatief zijn (μ_eff < 0) hoewel individuele metaalconstituenten niet-magnetisch zijn. Wat is de oorsprong van deze effectieve magnetisme?',
      [
        'Circulerende stromen in split-ring resonatoren geven een resonante magnetische respons',
        'Vrije elektronen in metaal verwerven orbitaal impulsmoment, nabootsen intrinsieke spinmagnetisme',
        'De plasmafrequentie van metaal verschuift onder operationele frequentie, keert permeabiliteitsteken om',
        'Niet-lineaire effecten bij hoge veldsterkte induceren permanente magnetisatie',
      ],
      0,
      'Plasmonische metamateriaal: split-ring resonatoren koppelen magnetisch veld → circulerende stroom → μ_eff < 0 nabij resonantie; effectieve LC-resonantie domineert.',
    ],
    [
      'In cryogene neutronendetectie met behulp van supervloeibaar ⁴He (supervloeibaar-He-doel) ioniseert kernterugslag de supervloeistof onmiddellijk en genereert quasideeltjesexcitaties waarneembaar via bolometer. Waarom bereikt deze aanpak gevoeligheid tot donkere-materiakandidaten met lage massa terwijl conventionele halfgeleiders niet kunnen?',
      [
        'Supervloeibaar He vangt terugslag die eV-bandspleten missen',
        'Supervloeibaar He heeft hogere dichtheid dan halfgeleiders, verhoogt doorsnede',
        'Helium is ongevoelig voor fotonachtergrondsignalen die halfgeleiderdetectoren kwellen',
        'Cryogene bolometerrespons is inherent sneller dan halfgeleiderelektronica',
      ],
      0,
      'Supervloeibaar ⁴He: ionisatie Eᵢ ∼ meV; lage-massa WIMP-terugslag (Eᵣ ∼ keV) produceert detecteerbare quasideeltjes; Ge/Si bandgap (eV) mist lage-massa-terugslagen.',
    ],
    [
      'In resonante inelastische röntgenverstrooiing (RIXS) op 3d-overgangsmetaal K-kanten, is intermediaire toestand een 1s kernhip gekoppeld aan 3d valentie-elektronen. Waarom bereikt RIXS excitaties (b.v. d-d-transities, magnonen) die dipoolverboden zijn in conventionele spectroscopie?',
      [
        'Resonantie staat multipooltransities toe die verboden zijn door dipoolregels van de grondtoestand',
        'RIXS geeft impulsresolutie, staat verstrooiingsvectoren toe die dipoolregels omzeilen',
        'De 1s kernhip screening verandert effectieve kernlading zien door 3d-elektronen, maakt nieuwe transities mogelijk',
        'RIXS-excitatiegolflengte kan worden afgestemd om dipolverboden lijnen te versterken',
      ],
      0,
      'RIXS: intermediaire 1s-kernhiptoestand staat kwadrupool-/hoger-multipoolkoppelingen toe; eindexcitaties van deze toestand hoeven grondtoestanddipoolregels niet te gehoorzamen.',
    ],
    [
      'In hogetemperatuursupergeleiders (kupraten) opent de pseudogap (PG) onder T* en onderdrukt spectrale gewicht op Fermilevel, toch opent de supergeleidingsgap onder T_c < T*. Wat is de relatie tussen PG en supergeleidingspairing, en waarom zijn ze duidelijke verschijnselen?',
      [
        'PG is een bosonische fluctuatieschaal boven T_c; SC-gap is fermionisch onder T_c',
        'PG en SC-gap zijn dezelfde verschijning; T_c meet wanneer pairingcoherentie begint, terwijl T* meet wanneer pairing begint',
        'PG is een toestandsdichtheidskenmerk; SC-gap is een transportverschijnsel',
        'PG ontstaat uit fonoscherming; SC-gap ontstaat uit elektron-elektron interacties',
      ],
      0,
      'Kupraat-pseudogap: bosonisch (PG ∝ spin-fluctuaties) boven T_c, overleeft tot T*; SC-gap (fermionisch, supergeleidingcoherentie) verschijnt onder T_c < T*.',
    ],
    [
      'In accretieschijfstraalingstransfer voldoet verticale structuur aan hydrostatisch evenwicht en stralingsenergibalans. Bij hoge accretietariffen (super-Eddington), wordt de schijf geometrisch dik. Wat veroorzaakt dat de schijf "opzwelt" en waarom beperkt dit de lokale stralingsefficiëntie?',
      [
        'Stralingsdruk domineert en doet de schijf opzwellen',
        'Magnetische instabiliteit (MRI) creëert turbulente verwarming die schijf opzwelt',
        'Thermische geleiding verplaatst verticaal energie, verlaagt lokale temperatuurgradiënt',
        'Bij super-Eddington tarief, nucleaire verbranding ontstaat in schijf, geeft extra steun',
      ],
      0,
      'Super-Eddington accretie: P_rad ∼ P_grav → dikke schijf; ingevangen straling verhoogt effectieve opaciteit; lokale stralingsefficiëntie η_rad < dun-schijf-limiet.',
    ],
    [
      'In tijdsopgeloste röntgendiffractie (TR-XRD) tijdens femtoseconde lasergeïnduceerde faseveranderingen, roosterdynamica worden bereikt via tijdsopgeloste veranderingen in diffractiepiekintensiteit en verbreding. Welke informatie over ultrasnelle fonondynamica is gecodeerd in de tijdsafhankelijke diffractielijnvorm (FWHM)?',
      [
        'FWHM volgt coherentielengte; het verval onthult de fonon-defaseringstijd',
        'FWHM meet densiteit van aangeslagen fonoenmodi; grotere FWHM geeft meer thermisch gevulde modi aan',
        'FWHM is alleen bepaald door instrumentele resolutie; ultrasnelle dynamica verschijnen alleen in piekverschuiving, niet verbreding',
        'FWHM codificeert fononenlevensduur (lijnbreedte); smalle FWHM geeft langlevende fonoenmodi aan',
      ],
      0,
      'TR-XRD piekverbreding: FWHM ∝ 1/ξ (coherentielengte); coherentiedefasering uit fononexcitatie verbreedt de piek; FWHM-verval onthult T₂.',
    ],
    [
      'In diffractieve röntgenoptiek voor synchrotrons, analyseerkristallen met asymmetrische Bragg-geometrie (asymmetrische snijhoek) vergroten de hoekacceptantie vergeleken met symmetrische geometrie. Hoe verbetert asymmetrie spectroscopische acceptantie zonder verlies van energieresolutie?',
      [
        'Asymmetrische sneden vergroten hoekacceptantie met behoud van Darwin-smallheid',
        'Asymmetrische sneden verminderen Darwin-breedte door meervoudige Bragg-reflecties te onderdrukken',
        'Asymmetrische geometrie verschuift reflectiviteitspiek weg van Darwin-curve, verlaagt dynamische verbreding',
        'Hoekvergroting ontstaat uit brekingsindex anisotropie geïntroduceerd door snijhoek',
      ],
      0,
      'Asymmetrische Bragg: Darwin-curve hoekbreedte = C × symmetrische breedte; vergroting C vergroot acceptantie terwijl dynamische smallheid behouden blijft.',
    ],
  ],
};
